import React from 'react';
import { MenuIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarOpen: boolean;
}

const Header = ({ setSidebarOpen, sidebarOpen }: HeaderProps) => {
  const { t } = useTranslation('common');

  if (sidebarOpen) {
    return null;
  }

  return (
    <button
      type="button"
      className="fixed top-[14px] left-3 z-50 p-2 text-zinc-500 hover:text-zinc-700 transition-colors duration-150 lg:hidden"
      onClick={() => setSidebarOpen(true)}
    >
      <span className="sr-only">{t('open-sidebar')}</span>
      <MenuIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
};

export default Header;
